export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: '⚡ Arrêtez d’Apprendre au Hasard',
    description:
      'Suivez une progression claire au lieu de passer constamment entre tutoriels, forums, vidéos et informations déconnectées.',
  },
  {
    title: '🏠 Passez de la Théorie à la Pratique',
    description:
      'Utilisez procédures, exemples, projets, exercices et checklists pour comprendre comment construire réellement un système domotique.',
  },
  {
    title: '🔗 Créez des Systèmes Plus Cohérents',
    description:
      'Apprenez à réfléchir à la compatibilité, aux protocoles, aux appareils et aux intégrations avant d’acheter et de configurer sans stratégie.',
  },
  {
    title: '🚀 Développez vos Compétences Étape par Étape',
    description:
      'Comprenez les fondamentaux, concevez, installez, automatisez et intégrez jusqu’à réaliser des projets domotiques complets.',
  },
]
